/* eslint-disable no-console */
import * as rax from "retry-axios";
import axios, { AxiosError, AxiosResponse } from "axios";
import APIUtils from "./utils.api";
import { EnvironmentConfig } from "../shared/types/config.types";
import { CONFIG_BASE_URL, CONFIG_ENDPOINT } from "./constants/urls.constants";

const CONFIG_API = axios.create({
  baseURL: CONFIG_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

CONFIG_API.defaults.raxConfig = {
  instance: CONFIG_API,
  statusCodesToRetry: [[0], [429], [599]],
  httpMethodsToRetry: ["GET", "HEAD", "OPTIONS"],
  shouldRetry: (err: AxiosError<any>) => APIUtils.handleShouldRetry(err, rax),
  onRetryAttempt: (err) => APIUtils.handleRetryAttempt(err, rax),
};

rax.attach(CONFIG_API);

const configAPI = {
  getConfig: async (): Promise<EnvironmentConfig> => {
    return CONFIG_API({
      method: "GET",
      url: CONFIG_ENDPOINT,
      data: {},
    })
      .then(function (response: AxiosResponse<EnvironmentConfig>) {
        return response.data;
      })
      .catch((error) => {
        console.log({ error });
        return Promise.reject(error);
      });
  },
};

export default configAPI;
